require('./mortgageRequestManagerDocuments.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');

//commons
const { ContentBox } = require('commonsComponents/contentBox');
const { OKLink } = require('commonsComponents/OKLink');

//constant
const { formatText, FormattedText } = require('core/i18n').i18n;
const DOCUMENTS_TYPES = require('constants/mortgageRequestDocumentsTypes');
const MAX_DOCUMENTS_MESSAGE_INFO = 4;
const mortgageRequestStates = require('constants/mortgageRequestStates');

class MortgageRequestManagerDocuments extends React.Component {
    constructor(props) {
        super(props);
    }

    handleDocumentDownload(e, docType) {
        const { requestDocument } = this.props;
        e.preventDefault();
        requestDocument({
            'documentType': docType,
        });
    }


    buildConditions() {
        const { isClientWithoutAccounts, flagBasedFeatures, immMortgageRequestState } = this.props;
        const flagFipreClient = flagBasedFeatures.get('manager-welcome-fipre-enabled');
        const flagFipreRNC = flagBasedFeatures.get('manager-welcome-fipre-rnc-enabled');
        const flagNewLawDoc1 = flagBasedFeatures.get('manager-welcome-new-law-doc1-enabled');
        const flagNewLawDoc2 = flagBasedFeatures.get('manager-welcome-new-law-doc2-enabled');
        const disclamer = isClientWithoutAccounts ? "mortgageRequestManagerDocuments-mortgageRequestManagerDocuments_RNCdisclamer1" : "mortgageRequestManagerDocuments-mortgageRequestManagerDocuments_disclamer1";
        let translation = isClientWithoutAccounts ? formatText('mortgageRequestManagerDocuments-mortgageRequestManagerDocuments_RNCdisclamer2') : formatText('mortgageRequestManagerDocuments-mortgageRequestManagerDocuments_disclamer2');
        let injectedLinks = [];
        let indexDocumentationCenter = 2;
        let insertNewCopies = 1;

        if (isClientWithoutAccounts && flagFipreRNC) {
            injectedLinks = [
                { docType: DOCUMENTS_TYPES.FIPRE, text: 'mortgageRequestManagerDocuments-mortgageRequestManagerDocuments_RNCdisclamerFIPRE' },
                { text: 'mortgageRequestManagerDocuments-mortgageRequestManagerDocuments_RNCdisclamerDOC' },
            ]
        } else if(!isClientWithoutAccounts && flagFipreClient) {
            injectedLinks = [
                { docType: DOCUMENTS_TYPES.FIPRE, text: 'mortgageRequestManagerDocuments-mortgageRequestManagerDocuments_disclamerFIPRE' },
                { text: 'mortgageRequestManagerDocuments-mortgageRequestManagerDocuments_disclamerDOC' },
            ]
        }

        if(flagNewLawDoc1) {
            injectedLinks.splice(insertNewCopies, 0, { docType: DOCUMENTS_TYPES.FIPRE, text: 'mortgageRequestManagerDocuments-mortgageRequestManagerDocuments_newMortgageLawDocument1' });
            indexDocumentationCenter += 1;
            insertNewCopies += 1;
        }
        if(flagNewLawDoc2) {
            injectedLinks.splice(insertNewCopies, 0, { docType: DOCUMENTS_TYPES.FIPRE, text: 'mortgageRequestManagerDocuments-mortgageRequestManagerDocuments_newMortgageLawDocument2' });
            indexDocumentationCenter += 1;
            insertNewCopies += 1;
        }

        const showOnlyOneNewLawDoc = MAX_DOCUMENTS_MESSAGE_INFO - 1; //one of new mortgage law documents is disabled

        if(indexDocumentationCenter === MAX_DOCUMENTS_MESSAGE_INFO) {
            translation = isClientWithoutAccounts ? formatText('mortgageRequestManagerDocuments-mortgageRequestManagerDocuments_RNCdisclamerfor3Documents') : formatText('mortgageRequestManagerDocuments-mortgageRequestManagerDocuments_disclamerFor3Documents');
        } else if(indexDocumentationCenter === showOnlyOneNewLawDoc) {
            translation = isClientWithoutAccounts ? formatText('mortgageRequestManagerDocuments-mortgageRequestManagerDocuments_RNCdisclamerfor2Documents') : formatText('mortgageRequestManagerDocuments-mortgageRequestManagerDocuments_disclamerFor2Documents');
        }

        const splitMessage = translation.split('%s');
        const message = splitMessage.map((msg, index) => {
            let fixIndex = index;

            if(index === indexDocumentationCenter) {
                fixIndex -= 1;
            }

            const documentName = injectedLinks[fixIndex] && injectedLinks[fixIndex].text !== '' ? (formatText(injectedLinks[fixIndex].text)) : '';
            let replacement;
            const documentationCenter = !!immMortgageRequestState && immMortgageRequestState.get('estado') !== mortgageRequestStates.SOLIC_PRESTAMO ? (
                <OKLink
                    to="/myprofile/mortgage/documentation"
                    modifier="link-emphasize"
                >
                    {documentName}
                </OKLink>
            ) : <span>{documentName}</span>;

            if (injectedLinks[fixIndex] && injectedLinks[fixIndex].docType && index !== indexDocumentationCenter) {
                replacement = (
                    <OKLink
                        onClick={evt => this.handleDocumentDownload(evt, injectedLinks[fixIndex].docType)}
                        modifier="link-emphasize"
                    >
                        {documentName}
                    </OKLink>
                )
            } else if (injectedLinks[fixIndex] && index === indexDocumentationCenter) {
                replacement = documentationCenter;
            }

            return (
                <span key={index}>
                    {msg}
                    {replacement}
                </span>
            );
        });

        return (
            <React.Fragment>
                <FormattedText
                    value={disclamer}
                    className="mortgage-request-manager-documents__disclamer"
                />
                {message}
            </React.Fragment>
        );
    }


    render() {
        const conditions = this.buildConditions();
        return (
            <div className="mortgage-request-manager-documents">
                <ContentBox>
                    <div className="mortgage-request-manager-documents__document">
                        <div className="mortgage-request-manager-documents__document--icon">
                            <i className="icon-documento doc"></i>
                        </div>
                        <div className="mortgage-request-manager-documents__document--info">
                            {conditions}
                        </div>
                    </div>
                </ContentBox>
                <p className="mortgage-request-manager-documents__footer">
                {formatText('mortgageRequestMortgageEdit-mortgagePreApprovalText')}
                </p>
            </div>
        );
    }

}

MortgageRequestManagerDocuments.propTypes = {
    flagBasedFeatures: PropTypes.object.isRequired,
    immMortgageRequestState: PropTypes.object,
    isClientWithoutAccounts: PropTypes.bool,
    requestDocument: PropTypes.func,
};

module.exports.MortgageRequestManagerDocuments = MortgageRequestManagerDocuments;
